import {appendPaginationQueryParamsToUrl, post} from '../utils'

const url = (host, reTags, retagMethod, visible, downloadable, accessLevel, options) => appendPaginationQueryParamsToUrl(`${host}/contentCreations/retagMasively?retags_ids=${reTags.join(',')}&update_downloadable=${downloadable}&update_visibility=${visible}&retag_method=${retagMethod}&access_level=${accessLevel}`, {...options, alreadyHasQueryParams: true});

export default host => (reTags, retagMethod, visible, downloadable, accessLevel, options) =>
  post(url(host, reTags, retagMethod, visible, downloadable, accessLevel, options))
